<script lang="ts">
    import {LayoutType} from "../common/types";
    import Svg from "../common/Svg.svelte";

    let {
        layout = $bindable()
    }: {
        layout: LayoutType;
    } = $props();

    $effect(() => {
        const types = [
            LayoutType.Grid,
            LayoutType.List,
            LayoutType.Dambord
        ];
        if (!types.includes(layout)) {
            layout = LayoutType.Grid;
        }
    })

    const buttons: {
        type: LayoutType;
        icon: "grid" | "list" | "square";
        label: string;
    }[] = [
        {
            type: LayoutType.Grid,
            icon: 'grid',
            label: 'Grid weergave'
        },
        {
            type: LayoutType.List,
            icon: 'list',
            label: 'Lijst weergave'
        },
        {
            type: LayoutType.Dambord,
            icon: 'square',
            label: 'Dambord weergave'
        }
    ];
</script>

<div class="layout-buttons">
    {#each buttons as button}
        <button
                class:active={layout===button.type}
                onclick={() => {
             layout = button.type
         }}
        >
            <Svg type={button.icon}/>
            {button.label}
        </button>
    {/each}
</div>

<style lang="scss">
  .layout-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    button {
      background: none;
      border: none;
      color: #1F4588;

      &.active {
        text-decoration: underline;
      }
    }
  }
</style>
